import { PriceHistory } from 'components/Main/Product/Lines/PriceHistory'
import ProductLinesForm from '../../../../components/Main/Product/Lines/ProductLinesForm'
import ProductLinesCostForm from '../../../../components/Main/Product/Lines/ProductLinesCostForm'
import ProductLinesShippingForm from '../../../../components/Main/Product/Lines/ProductLinesShippingForm'
import React from 'react'
import { Modal, Tabs } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

const { TabPane } = Tabs

function ProductLinesModal(props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
    isUpdatable,
    product,
    line,
  } = props
  const isNew = modalType === 'new'
  const isRemovable = product.status !== 'Confirmed' && product.status !== 'Revised'

  return (
    <Modal
      visible={visible}
      title={'SKU DETAILS'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={isUpdatable}
          submit={submit}
          remove={remove}
          update={update}
          isRemovable={isRemovable}
          removing={removing}
          submitting={submitting}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <Tabs defaultActiveKey="details">
        <TabPane tab="Sell Details" key="details">
          <ProductLinesForm ref={formRef} {...props} />
        </TabPane>
        <TabPane tab="Buy Details" key="cost">
          <Tabs defaultActiveKey="buyDetails">
            <TabPane tabPosition="left" tab="Details" key="buyDetails">
              <ProductLinesCostForm ref={formRef} {...props} />
            </TabPane>
            <TabPane tab="Price History" key="history">
              <PriceHistory id={line._key} type="buyRate" />
            </TabPane>
          </Tabs>
        </TabPane>
        <TabPane tab="Shipping Details" key="shipping">
          <ProductLinesShippingForm ref={formRef} {...props} />
        </TabPane>
      </Tabs>
    </Modal>
  )
}

ProductLinesModal.propTypes = {}
ProductLinesModal.defaultProps = {}

export default ProductLinesModal
